import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { WalletProvider } from "@/context/WalletContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { StarField } from "@/components/StarField";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

import Landing from "@/pages/Landing";
import ExploreMars from "@/pages/ExploreMars";
import Lore from "@/pages/Lore";
import ExplorerProfile from "@/pages/ExplorerProfile";
import HallOfExplorers from "@/pages/HallOfExplorers";
import Marketplace from "@/pages/Marketplace";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const noFooter = pathname.startsWith("/explore") || pathname.startsWith("/admin");
  return (
    <>
      <StarField />
      <div className="grain" />
      <Navbar />
      <main className="relative">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/explore" element={<ExploreMars />} />
          <Route path="/lore" element={<Lore />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/hall" element={<HallOfExplorers />} />
          <Route path="/profile" element={<ExplorerProfile />} />
          <Route path="/profile/:id" element={<ExplorerProfile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!noFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-deepspace">
      <BrowserRouter>
        <LanguageProvider>
          <WalletProvider>
            <ScrollToTop />
            <Shell />
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#090d1f", border: "1px solid rgba(0,212,255,0.3)", color: "#fff", fontFamily: "IBM Plex Mono, monospace", fontSize: "0.8rem" } }} />
          </WalletProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
